/* eslint-disable max-lines */
/* eslint-disable max-len */
import React from 'react';
import {FilterDays, detectOrderDates, filterNumeric} from '../../../utils/commonUtils';
import {scopes} from '../../../../common/permissions/dictionary';
import {Popup} from 'semantic-ui-react';

export const tableColumnsWithProps = ({
  setOpenOrders,
  setOrdersInput,
  selectMode,
  updateMyData,
  setSelectedVehicleCombo,
  setOpenComboModal,
  dispatch,
  fetchPriorizationCombos,
  userType,
  setOpenAgencyModals,
  setSelectedVehicleAgency,
  fetchAgenciesByDealer,
  isUserTDE,
}) => {
  const dealerHiddenColums = [
    'movementScheduledDate',
    'hunterScheduledDate',
    'accessoriesScheduledDate',
    'pdsScheduledDate',
    'status',
  ];
  const select = [
    {
      'Header': () => <span className="header-title"></span>,
      'accessor': 'isSelected',
      'className': 'cell-custom-inventory-models',
      'Filter': () => null,
    },
  ];

  const columns = [
    {
      'Header': () => <span className="header-title">LINEA</span>,
      'title': 'LINEA',
      'accessor': 'line',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">PEDIDO</span>,
      'title': 'PEDIDO',
      'accessor': 'order',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">RESERVADO PARA</span>,
      'title': 'RESERVADO PARA',
      'accessor': 'reservationName',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'title': 'DESCRIPCIÓN',
      'accessor': 'model',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">SFX</span>,
      'title': 'SFX',
      'accessor': 'sfx',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">FECHA LIQUIDACIÓN</span>,
      'title': 'FECHA LIQUIDACION',
      'accessor': 'liquidationDate',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        return <>{((row.original.liquidationDate) || '')?.substring(0, 10)}</>;
      },
    },
    {
      'Header': () => <span className="header-title">FACTURAR A</span>,
      'title': 'FACTURAR A',
      'accessor': 'invoiceName',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">CONCESIONARIO DESTINO</span>,
      'title': 'DEALER DESTINO',
      'accessor': 'dealerDestinyName',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">AGENCIA</span>,
      'title': 'AGENCIA',
      'accessor': 'agencyName',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        const handleUpdateAgency = () => {
          dispatch(fetchAgenciesByDealer({
            'dealerId': row.original.dealerDestiny,
            'priorization': 'S',
          }));
          dispatch(fetchPriorizationCombos(
            row.original.reservationId,
            row.original.masterCode,
            row.original.sfx
          ));
          dispatch(setSelectedVehicleAgency({
            'chassis': row.original.chassis,
            'dealerDestiny': row.original.dealerDestiny,
            'agency': row.original.agency,
          }));
          setOpenAgencyModals(true);
        };
        if ((userType === scopes.LogisticEdit || userType === scopes.Edit || userType === scopes.SalesEdit) &&
          (!row.original.haveOpenCloseOrders && (row.original.prioritizationDate || row.original.prioritizationDateMod))) {
          return (
            <div
              className='pointer text-primary'
              onClick={handleUpdateAgency}
            >
              {row.original.agencyName}
            </div>
          );
        }
        return (
          <div>{row.original.agencyName}</div>
        );
      },
    },
    {
      'Header': () => <span className="header-title">UBICACIÓN</span>,
      'title': 'UBICACIÓN',
      'accessor': 'location',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">CHASIS</span>,
      'title': 'CHASIS',
      'accessor': 'chassis',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">MOTOR</span>,
      'title': 'MOTOR',
      'accessor': 'motor',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO COLOR</span>,
      'title': 'CÓDIGO COLOR',
      'accessor': 'externalColor',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">COLOR</span>,
      'title': 'COLOR',
      'accessor': 'colorName',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO COLOR INTERIOR</span>,
      'title': 'CÓDIGO COLOR INTERIOR',
      'accessor': 'internalColor',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">COLOR INTERIOR</span>,
      'title': 'COLOR INTERIOR',
      'accessor': 'internalColorName',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">AÑO MODELO</span>,
      'title': 'AÑO MODELO',
      'accessor': 'yearModel',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">DIAS ANTIGUEDAD</span>,
      'title': 'DIAS ANTIGUEDAD',
      'accessor': 'daysOld',
      'width': 150,
      'Filter': FilterDays,
      'filter': filterNumeric,
      'Cell': ({row}) => {
        const getColor = (daysOld) => {
          if (daysOld < 30) {
            return 'color-green';
          } else if (daysOld >= 30 && daysOld <= 60) {
            return 'color-yellow';
          } else if (daysOld > 60) {
            return 'color-red';
          }
        };
        return (
          <div className={getColor(row.original.daysOld)}>
            {row.original.daysOld < 0 ?
              `en ${Math.abs(row.original.daysOld)} días` :
              `hace ${Math.abs(row.original.daysOld)} días`
            }
          </div>
        );
      },
    },
    {
      'Header': () => (
        <>
          {
            selectMode ? (<>MOV.</>) : (
              <span
                className="header-title pointer text-primary"
                onClick={() => {
                  setOpenOrders(true);
                  setOrdersInput({
                    'name': 'MOVILIZACIÓN',
                    'value': 'MOV',
                  });
                }}
              >
                  MOV.
              </span>

            )
          }
        </>
      ),
      'title': 'MOVILIZACIÓN',
      'accessor': 'movementScheduledDate',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        const {movementScheduledDate, movementCloseDate} = row.original;
        const [value, color] = detectOrderDates(movementScheduledDate, null, movementCloseDate);
        return <div className={color}>{value}</div>;
      },
    },
    {
      'Header': () => (
        <>
          {
            selectMode ? (<>HUNTER</>) : (
              <span
                className="header-title pointer text-primary"
                onClick={() => {
                  setOpenOrders(true);
                  setOrdersInput({
                    'name': 'HUNTER',
                    'value': 'HU',
                  });
                }}
              >
                  HUNTER
              </span>
            )
          }
        </>
      ),
      'title': 'HUNTER',
      'accessor': 'hunterScheduledDate',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        const {hunterScheduledDate, hunterCloseDate} = row.original;
        const [value, color] = detectOrderDates(hunterScheduledDate, null, hunterCloseDate);
        return <div className={color}>{value}</div>;
      },
    },
    {
      'Header': () => (
        <>
          {
            selectMode ? (<>ACCESORIOS</>) : (
              <span
                className="header-title pointer text-primary"
                onClick={() => {
                  setOpenOrders(true);
                  setOrdersInput({
                    'name': 'ACCESORIOS',
                    'value': 'ACC',
                  });
                }}
              >
                ACCESORIOS
              </span>
            )
          }
        </>
      ),
      'title': 'ACCESORIOS',
      'accessor': 'accessoriesScheduledDate',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        const {accessoriesScheduledDate, accessoriesOpenDate, accessoriesCloseDate} = row.original;
        const [value, color] = detectOrderDates(accessoriesScheduledDate, accessoriesOpenDate, accessoriesCloseDate);
        return <div className={color}>{value}</div>;
      },
    },
    {
      'Header': () => (
        <>
          {
            selectMode ? (<>PDS</>) : (
              <span
                className="header-title pointer text-primary"
                onClick={() => {
                  setOpenOrders(true);
                  setOrdersInput({
                    'name': 'PDS',
                    'value': 'PDS',
                  });
                }}
              >
                  PDS
              </span>
            )
          }
        </>
      ),
      'title': 'PDS',
      'accessor': 'pdsScheduledDate',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        const {pdsScheduledDate, pdsOpenDate, pdsCloseDate} = row.original;
        const [value, color] = detectOrderDates(pdsScheduledDate, pdsOpenDate, pdsCloseDate);
        return <div className={color}>{value}</div>;
      },
    },
    {
      'Header': () => <span className="header-title">REPROCESO</span>,
      'title': 'REPROCESO',
      'accessor': 'reprocessingDate',
      'Cell': ({row}) => <>{(row.original.reprocessingDate || '').substring(0, 10)}</>,
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'title': 'ESTADO',
      'accessor': 'status',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">OBSERVACIÓN LOGÍSTICA</span>,
      'title': 'OBSERVACIÓN LOGÍSTICA',
      'accessor': 'comments',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">OBSERVACIÓN COMERCIAL</span>,
      'title': 'OBSERVACIÓN COMERCIAL',
      'accessor': 'comercialObservation',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => (
        <>
          <Popup
            trigger={
              <div className="dot">
                {row.original?.comercialObservation?.length || 0}
              </div>
            }
            position="top center"
            size="small"
            disabled={!row?.original?.comercialObservation?.length}
            inverted
          >
            <Popup.Content style={{'fontSize': '9px'}}>
              <table>
                <tbody>
                  {row?.original?.comercialObservation?.map((observation, index) => (
                    <tr>
                      <td>{observation.incomeComments}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Popup.Content>
          </Popup>
        </>
      ),
    },
    {
      'Header': () => <span className="header-title">COMBO</span>,
      'title': 'COMBO',
      'accessor': 'comboCode',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        const handleUpdateCombo = () => {
          dispatch(fetchPriorizationCombos(
            row.original.reservationId,
            row.original.masterCode,
            row.original.sfx
          ));
          dispatch(setSelectedVehicleCombo({
            'chassis': row.original.chassis,
            'comboCode': row.original.comboCode,
          }));
          setOpenComboModal(true);
        };
        if (userType === scopes.LogisticEdit &&
          (!row.original.haveOpenCloseOrders && (row.original.prioritizationDate || row.original.prioritizationDateMod))) {
          return (
            <div
              className='pointer text-primary'
              onClick={handleUpdateCombo}
            >
              {row.original.comboCode}
            </div>
          );
        }
        return (
          <div>{row.original.comboCode}</div>
        );
      },
    },
    {
      'Header': () => <span className="header-title">DISPOSITIVO</span>,
      'title': 'DISPOSITIVO',
      'accessor': 'hunter',
      'className': 'cell-custom-inventory-models',
    },
    {
      'Header': () => <span className="header-title">{userType === scopes.LogisticEdit ? 'FECHA ENTREGA' : 'FECHA DE DESPACHO'}</span>,
      'title': 'FECHA DE DESPACHO',
      'accessor': 'prioritizationDate',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        return <>{((row.original.reprocessingDatePlusOne || row.original.prioritizationDateMod || row.original.prioritizationDate) || '')?.substring(0, 10)}</>;
      },
    },
    {
      'Header': () => <span className="header-title">FECHA FACTURACIÓN</span>,
      'title': 'FECHA FACTURACIÓN',
      'accessor': 'pdsOpenDate',
      'className': 'cell-custom-inventory-models',
      'Cell': ({row}) => {
        const {pdsScheduledDate, pdsOpenDate, pdsCloseDate} = row.original;
        const [value] = detectOrderDates(pdsScheduledDate, pdsOpenDate, pdsCloseDate);
        const reprocessingDate = row.original.reprocessingDate?.substring(0, 10);
        return <div>{reprocessingDate || value}</div>;
      },
    },
  ];
  const columnsByRole = isUserTDE ? columns : columns.filter((column) => !dealerHiddenColums.includes(column.accessor));

  return selectMode ? [...select, ...columnsByRole] : columnsByRole;
};
